import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsHeadingBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsHeadingBlockEntity
